module.exports = __webpack_public_path__ + "media/entities/1603-c5cda2d0.png";